<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pb-2 mt-1" >
                <v-col sm="8" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('slots.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <v-row class="mx-0 my-0 px-0 py-0" justify="end">
                        <v-btn class="right white_highlight--text tools-view-height" color="secondary" :to="'/slots/create'" v-permission="'slot.create'">
                            {{ $t('slots.new') }}
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :props="{headers:headers, items: props.items, search:props.search}" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-dialog v-model="modalDetail" persistent max-width="90%">
                <v-card >
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h4 class="text-uppercase blue_accent--text py-2">
                                {{ $t('slots.header') }} {{ this.slot.id }}
                            </h4>
                        </v-row>
                    </v-card-title>
                    
                    <div class="marker1-1" style="font-weight:bold"><label class="mx-1">{{ $t('slots.details') }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("slots.name") }}</label> <label>{{ this.slot.name }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("slots.position") }}</label> <label>{{ this.slot.position }}</label></div>
                                         
                    <div class="marker1-1 mt-2 detail_content1" style="font-weight:bold;" v-if="slot.tote != null"><label class="mx-1">{{ $t('slots.tote') }}</label></div>
                    <div class="detail_content1" v-if="slot.tote != null"><label style="font-weight:bold">{{ $t("slots.id") }}</label> <label>{{ this.slot.tote.id }}</label></div>
                    <div class="detail_content1" v-if="slot.tote != null"><label style="font-weight:bold">{{ $t("slots.name") }}</label> <label>{{ this.slot.tote.name }}</label></div>
                    <div class="detail_content1" v-if="slot.tote != null"><label style="font-weight:bold">{{ $t("slots.shipment_id") }}</label> <label>{{ this.slot.tote.shipment_id }}</label></div>
                    <div class="detail_content1" v-if="slot.tote != null"><label style="font-weight:bold">{{ $t("slots.shipment_type") }}</label> <label>{{ this.slot.tote.shipment_type }}</label></div>

                    <div class="marker1-1 mt-2 detail_content1" style="font-weight:bold;" v-if="slot.station != null"><label class="mx-1">{{ $t('slots.station') }}</label></div>
                    <div class="detail_content1" v-if="slot.station != null"><label style="font-weight:bold">{{ $t("slots.id") }}</label> <label>{{ this.slot.station.id }}</label></div>
                    <div class="detail_content1" v-if="slot.station != null"><label style="font-weight:bold">{{ $t("slots.name") }}</label> <label>{{ this.slot.station.name }}</label></div>
                    <div class="detail_content1" v-if="slot.station != null"><label style="font-weight:bold">{{ $t("slots.user_id") }}</label> <label>{{ this.slot.station.user_id }}</label></div>
                    <v-card-text class="mt-5">
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn color="secondary" class="white_highlight--text" @click="modalDetail = false">
                                {{ $t('slots.close') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
            </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>

import { slotIndexUseCase } from "../application/use_cases/slot_index_use_case";
import { slotShowUseCase } from "../application/use_cases/slot_show_use_case";
import { HttpSlotRepository } from "../infrastructure/slot_repository";

export default {
    computed: {
        headers(){
            return [
                { text: this.$t('slots.id'), align: "center", value: 'id', class: 'text-uppercase' }, 
                { text: this.$t('slots.name'), align: "center", value: 'name', class: 'text-uppercase' },
                // { text: this.$t('slots.tote'), align: "center", value: 'tote_id', class: 'text-uppercase' },
                // { text: this.$t('slots.station'), align: "center", value: 'station_id', class: 'text-uppercase' },
                { text: this.$t('slots.position'), align: "center", value: 'position', class: 'text-uppercase' },
                { text: this.$t('slots.actions'), align: "center", value: 'actions', class: 'text-uppercase' }
            ];
        } 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            modalDetail: false,
            idStation: '',
            slot: {
                "id": "",
                "name": "",
                "tote_id":  null,
                "station_id": null,
                "tote": {
                    "id": null,
                    "name": null,
                    "slot_id": null,
                    "shipment_id": null,
                    "shipment_type": null,
                    "warehouse_id": null
                },
                "station": {
                    "id": null,
                    "name": null,
                    "user_id": null,
                    "warehouse_id": null
                },
                "position": ""
            },
            props: {
                search: '',
                items: [],
            }
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.slots";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async index(){
            this.props.items = [];
            const result = await slotIndexUseCase(HttpSlotRepository);
            this.props.items = result;
        },
        async show(slot){
            const result = await slotShowUseCase(slot.id, HttpSlotRepository);
            this.slot = result;
            this.modalDetail = true;
        }
    }
}
</script>

<style>

</style>